import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6fba2a4c&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=6fba2a4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fba2a4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fba2a4c')) {
      api.createRecord('6fba2a4c', component.options)
    } else {
      api.reload('6fba2a4c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6fba2a4c&scoped=true&", function () {
      api.rerender('6fba2a4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/map/index.vue"
export default component.exports